<template>
  <div class="topbar">
    <TextBody i18n-key="account.myCreations" tag="span" />
    <BbBtn size="x-small" type="icon" icon="x-small" icon-size="medium" no-background @click="goBackToAuthor" />
  </div>
  <div class="content">
    <TextBody :text="title" tag="span" :body-type="4" weight="medium" />
    <div v-if="!isDataLoading" class="creations-container">
      <CreationsCard
        v-for="(document, index) in authoredDocuments"
        :key="document.id"
        :creation="document"
        :index="index + 1"
      />
    </div>
    <div v-else class="creations-container">
      <BbSkeletonLoader type="card" class="creation-skeleton" />
      <BbSkeletonLoader type="card" class="creation-skeleton" />
      <BbSkeletonLoader type="card" class="creation-skeleton" />
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { computed, onMounted, ref } from 'vue';

import TextBody from '~/components/common/TextBody.vue';
import CreationsCard from '~/components/myCreations/CreationsCard.vue';
import useDocuments from '~/composables/useDocuments';

export default {
  components: { TextBody, CreationsCard },

  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const { authoredDocuments, getAuthoredDocuments } = useDocuments();

    const isDataLoading = ref(true);

    const title = computed(() => `${t('account.myCreations')} (${authoredDocuments.value.length})`);

    const goBackToAuthor = () => router.back();

    onMounted(async () => {
      await getAuthoredDocuments();
      isDataLoading.value = false;
    });

    return { title, goBackToAuthor, authoredDocuments, isDataLoading };
  },
};
</script>

<style scoped lang="scss">
.topbar {
  padding: $bb-spacing-5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: $bb-neutral-0;
  border-bottom: 1px solid $bb-neutral-4;
}

.content {
  background: $bb-neutral-0;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: $bb-spacing-5 $bb-spacing-6;

  :deep(.body-4) {
    color: $bb-neutral-1 !important;
    font-size: 18px !important;
    line-height: 22px;
    letter-spacing: -0.3px;
  }

  .creations-container {
    gap: $bb-spacing-8;
    margin-top: $bb-spacing-10;
    display: flex;
    flex-wrap: wrap;

    .creation-skeleton {
      width: 291px;
      height: 288px;
    }

    @media (max-width: 992px) {
      grid-template-columns: auto;
    }
  }
}
</style>
